var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownBlackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.457874 0.456C-0.150126 1.096 -0.150126 2.088 0.457874 2.696C2.79387 5.064 6.63387 9.128 6.69787 9.192C7.01787 9.512 7.43387 9.672 7.84987 9.672C8.23387 9.672 8.64987 9.512 8.96987 9.192C9.03387 9.128 13.1299 5.128 15.4659 2.76C16.0739 2.152 16.0739 1.16 15.4659 0.52C14.8579 -0.088 13.8339 -0.088 13.2259 0.52L7.84987 5.832L2.69787 0.456C2.08987 -0.152 1.06587 -0.152 0.457874 0.456Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownBlackArrow);
export default __webpack_public_path__ + "static/media/down_black_arrow.58cea990839074e783f8475e4a1a1363.svg";
export { ForwardRef as ReactComponent };